import { render, staticRenderFns } from "./DelegationDataTable.vue?vue&type=template&id=614b56b6&scoped=true&"
import script from "./DelegationDataTable.vue?vue&type=script&lang=ts&"
export * from "./DelegationDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./DelegationDataTable.vue?vue&type=style&index=0&id=614b56b6&scoped=true&lang=scss&"
import style1 from "./DelegationDataTable.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DelegationDataTable.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b56b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDataTable,VSwitch})
